module.exports = __webpack_public_path__ + "img/listMode.de8f1a6c.svg";